import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-59dfc4b0")

_pushScopeId("data-v-59dfc4b0")
const _hoisted_1 = { class: "HorizontalButtonDialog__content" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")
  const _component_ButtonRack = _resolveComponent("ButtonRack")
  const _component_Icon = _resolveComponent("Icon")
  const _component_SwipeablePanel = _resolveComponent("SwipeablePanel")

  return (_openBlock(), _createBlock("div", {
    class: "HorizontalButtonDialog",
    onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode("div", {
      class: "HorizontalButtonDialog__overlay",
      onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('close')))
    }),
    _createVNode(_component_SwipeablePanel, {
      animation: "",
      "hide-head": "",
      onClose: _cache[5] || (_cache[5] = $event => (_ctx.$emit('close', $event)))
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", {
            innerHTML: _ctx.message,
            class: "HorizontalButtonDialog__message"
          }, null, 8, ["innerHTML"]),
          _createVNode(_component_ButtonRack, {
            direction: _ctx.ButtonRackDirectionType.VERTICAL
          }, {
            default: _withId(() => [
              _createVNode(_component_Button, {
                color: _ctx.ButtonThemeStyle.PRIMARY,
                size: _ctx.ButtonSizeStyle.H50,
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('click', _ctx.action1))),
                disabled: _ctx.action1.disabled
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.action1.text), 1 /* TEXT */)
                ]),
                _: 1
              }, 8, ["color", "size", "disabled"]),
              (_ctx.action2 != null)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    color: _ctx.ButtonThemeStyle.OUTLINE_PRIMARY,
                    size: _ctx.ButtonSizeStyle.H50,
                    onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('click', _ctx.action2))),
                    disabled: _ctx.action2.disabled
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.action2.text), 1 /* TEXT */)
                    ]),
                    _: 1
                  }, 8, ["color", "size", "disabled"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["direction"])
        ]),
        (_ctx.closeable)
          ? (_openBlock(), _createBlock(_component_Icon, {
              key: 0,
              class: "HorizontalButtonDialog__close-button",
              type: _ctx.IconType.IC_24_CLOSE_SMALL,
              size: 18,
              onClick: _cache[4] || (_cache[4] = $event => (_ctx.$emit('close')))
            }, null, 8, ["type"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})